import React from 'react'

export default function ErrorTableIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="42" viewBox="0 0 38 42" fill="none">
    <path d="M37.0049 24.3423C32.1117 19.4491 25.4752 16.7002 18.5552 16.7002C11.6352 16.7002 5.89316 18.5546 0.999991 23.4478" stroke="black"/>
    <circle cx="7.15621" cy="4.56978" r="4.56978" fill="#5F5F5F"/>
    <circle cx="30.8466" cy="4.56978" r="4.56978" fill="#5F5F5F"/>
    </svg>
  )
}
